import { createSlice } from '@reduxjs/toolkit'

// Slice


const initialUser = null

const slice = createSlice({
  name: 'user',
  initialState: {
    user: initialUser,
  },
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
    //   localStorage.setItem('user', JSON.stringify(action.payload))
    },
    logoutSuccess: (state, action) =>  {
      // state.user = null;
      // state.dashboard = null;
      // state.docuement = null;
      sessionStorage.removeItem('token');
      // this.props.history.replace("/login")
      localStorage.clear();
      window.location.href = '/';
    },
    reset: state => initialUser
  },
});

export default slice.reducer

// Actions

const { loginSuccess, logoutSuccess,reset } = slice.actions

export const login = (user) => async dispatch => {
  try {
    // await api.post('/api/auth/login/', { username, password })
    dispatch(loginSuccess(user));
  } catch (e) {
    return console.error(e.message);
  }
}

export const logout = () => async dispatch => {
  try {
    // await api.post('/api/auth/logout/')
    await dispatch(reset())
    return dispatch(logoutSuccess())
  } catch (e) {
    return console.error(e.message);
  }
}